module.exports = __webpack_public_path__ + "img/globe-asia.77270018.svg";